import { Injectable } from '@angular/core'
import { AccountInfo } from '@interserve/angular'
import { Subject } from 'rxjs'
import { environment } from '../../../environments/environment'
import { IsTokenService } from '@interserve/angular'

declare const window: {
  location: { origin: string }
  BeLoginCore: {
    login: () => void
    logout: () => void
  }
}
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private account: AccountInfo | undefined
  private appCd = environment.appCd
  private autoLoginAccountId: string | null = null // 自動ログインさせる際に利用
  private loginStatus: boolean = true

  constructor(private isTokenService: IsTokenService) {}

  private accountSource = new Subject<AccountInfo | undefined>()
  accountSource$ = this.accountSource.asObservable()

  get Account(): AccountInfo | undefined {
    return this.account
  }
  setAccount(account: AccountInfo | undefined): void {
    this.account = account
    this.accountSource.next(account)
  }

  // 自動ログインさせる際に設定
  public setAutoLoginAccountId(autoLoginAccountId: string): void {
    this.autoLoginAccountId = autoLoginAccountId
  }
  public get AutoLoginAccountId(): string | null {
    return this.autoLoginAccountId
  }
  public resetAutoLoginAccountId(): void {
    this.autoLoginAccountId = null
  }

  get LoginStatus(): boolean {
    return this.loginStatus
  }
  public setLoginStatus(loginStatus: boolean) {
    this.loginStatus = loginStatus
    this.loginStatusSource.next(loginStatus)
  }
  private loginStatusSource = new Subject<boolean>()
  loginStatusSource$ = this.loginStatusSource.asObservable()

  clear(): void {
    this.account = undefined
  }

  logout(): void {
    this.clear()
    this.isTokenService.setToken('')
    this.isTokenService.setLocalStorageToken('')

    this.resetAutoLoginAccountId()
    this.setLoginStatus(false)

    window.BeLoginCore.logout()
    // location.reload()
  }
}
